import http from './_http'
import config from "@/config";

/**
 * 自动登录，或者手机授权
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const commonUploadSignature = (params = {}) => {
    return http({
        url: '/common/upload_signature',
        method: 'get',
        params,
    });
}

/**
 * 发送验证码
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const commonSendCheckCodeSms = (params = {}) => {
    return http({
        url: '/common/send_check_code_sms',
        method: 'post',
        params,
    });
}

/**
 * 获取公共配置
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const commonConfig = (params = {}) => {
    return http({
        url: '/common/config',
        method: 'get',
        params,
    });
}

/**
 * 获取小程序码
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const commonWxacode = (params = {}) => {
    return http({
        url: '/common/wxacode',
        method: 'post',
        params: { wxMiniAppId: config.appid, ...params },
        meta: {
            login: true,
            loading: true,
        }
    });
}

/**
 * 获取公众号 jssdk 鉴权 签名
 * @returns {Promise | Promise<unknown>}
 * @param link
 */
export const commonMpSignature = (link) => {
    return http({
        url: '/common/mp_signature',
        method: 'get',
        params: { appId: config.appid, link },
        meta: {}
    });
}
